import { z } from "zod";
import { passwordRegex } from "../utils/password/passwordRegex";

export const TChangePwd = z
  .object({
    old_password: z.string().trim().min(6, "Current password is required"),
    new_password: z
      .string()
      .trim()
      .min(6, "New password is required")
      .regex(
        passwordRegex,
        "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character",
      ),
    confirmPassword: z
      .string()
      .trim()
      .min(6, "Confirm password is required")
      .optional(),
  })
  .refine((data) => data.new_password === data.confirmPassword, {
    message: "Passwords must match",
    path: ["confirmPassword"],
  });

export type TChangePwdSchema = z.input<typeof TChangePwd>;
